export default __webpack_public_path__ + "static/media/palm-nut.b885732c.png";